import axios from "axios";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import { DataGrid } from "@mui/x-data-grid";
import { green, yellow } from "@mui/material/colors";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import LogoutIcon from "@mui/icons-material/Logout";
import CustomTabPanel from "../components/CustomTabPanel";
import OrderHistory from "../components/OrderHistory";
import Wishlist from "../components/Wishlist";

import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import testImg from "../photos/product_1.jpg";

import "../style/profile.css";

// Icon
import EditIcon from "@mui/icons-material/Edit";

const Profile = () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const [value, setValue] = useState(0);
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    ...theme.applyStyles("dark", {
      backgroundColor: "#1A2027",
    }),
  }));

  const { id } = useParams();
  const [user, setUser] = useState({
    username: "",
    user_email: "",
    user_contact: "",
  });
  const [profInfo, setProfInfo] = useState({
    name: "",
    emailAddress: "",
    phoneNumber: "",
  });
  const [orderHistory, setorderHistory] = useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    axios
      .get(`${baseURL}/profile/${id}`)
      .then((response) => {
        setUser(response.data);
      })
      .catch((error) => {
        console.error("Error fetching product:", error);
      });
  }, []);

  useEffect(() => {
    const fetchCartItems = async () => {
      try {
        const response = await fetch(`${baseURL}/orderhistory-view`, {
          method: "GET",
          credentials: "include",
        });

        const data = await response.json();
        const cartItems = data.orderHistory.map((order) =>
          JSON.parse(order.order_items),
        );

        // Fetch product details
        if (cartItems.length > 0) {
          const productIds = cartItems.flat().map((item) => item.prod_id);

          const productResponse = await fetch(
            `${baseURL}/get-products?ids=${productIds.join(",")}`,
            {
              method: "GET",
            },
          );

          if (!productResponse.ok) {
            throw new Error("Failed to fetch product details");
          }

          const products = await productResponse.json();

          // Map cart items back into nested structure with product details
          const enrichedCartItems = cartItems.map((orderItems) =>
            orderItems.map((cartItem) => {
              const product = products.find(
                (p) => p.prod_id === cartItem.prod_id,
              );
              return {
                ...cartItem,
                prod_name: product?.prod_name || null,
                prod_price: product?.prod_price || null,
                prod_image: product?.prod_image || null,
                prod_expiry: product?.prod_expiry || null,
                prod_quan: cartItem.prod_quan || null, // Preserve quantity
              };
            }),
          );

          setCartItems(enrichedCartItems); // Store the enriched cart items with product details
          setorderHistory(data.orderHistory);
        } else {
          setCartItems([]); // No items in the cart
        }
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    };

    // Trigger the fetch on component load
    fetchCartItems();
  }, []);

  const handleLogout = async () => {
    try {
      await fetch(`${baseURL}/logout`, {
        method: "POST",
        credentials: "include", // Important for cookies!
      });
    } catch (error) {
      console.error("Logout failed:", error);
    }

    window.location.href = "/"; // Redirect to login page
  };

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };

  const handleProfileChange = () => {};

  const handleEditProfile = async () => {
    try {
      const response = await fetch(`${baseURL}/users/update`, {
        method: "PUT", // or "POST" depending on your API
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          name: user.username,
          email: user.user_email,
          contactNumber: user.user_contact,
        }),
        withCredentials: true,
      });

      if (response.ok) {
        setIsEdit(false); // Turn off edit mode after saving
        window.location.reload();
      } else {
        console.error("Failed to update user");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <Box sx={{ px: 4, textAlign: "center" }}>
      {" "}
      <h1>Profile</h1>
      <Grid
        container
        spacing={0}
        direction="row"
        alignItems="flex-start"
        justifyContent="center"
      >
        <Grid item size={4} sx={{ p: 1, textAlign: "left" }}>
          <Box component="section">
            <Box>
              {" "}
              <Grid container direction="column" spacing={4}>
                <Grid Item direction="column">
                  {user == null ? (
                    <h3>Error</h3>
                  ) : (
                    <Box>
                      <Grid
                        container
                        direction={"row"}
                        sx={{ justifyContent: "space-between" }}
                      >
                        {" "}
                        <span>
                          <b style={{ fontSize: "1rem" }}>User Information</b>
                          <button className="remove">
                            {" "}
                            <EditIcon
                              sx={{ fontSize: "medium" }}
                              onClick={() => setIsEdit((prev) => !prev)}
                            />
                          </button>
                        </span>
                        <button onClick={handleLogout} className="remove">
                          <LogoutIcon sx={{ fontSize: "medium" }} />
                        </button>
                      </Grid>

                      <p>
                        <b>Name </b>
                        <br />
                        <TextField
                          disabled={!isEdit}
                          id="standard"
                          variant="standard"
                          value={user.username}
                          sx={{ width: "100%" }}
                          onChange={(e) => {
                            setUser({ ...user, username: e.target.value });
                          }}
                        />
                      </p>

                      <p>
                        <b>Email </b>
                        <br />
                        <TextField
                          disabled={!isEdit}
                          id="standard"
                          variant="standard"
                          value={user.user_email}
                          sx={{ width: "100%" }}
                          onChange={(e) => {
                            setUser({ ...user, user_email: e.target.value });
                          }}
                        />
                      </p>
                      <p>
                        <b>Phone Number </b>
                        <br />
                        <TextField
                          disabled={!isEdit}
                          id="standard"
                          variant="standard"
                          sx={{ width: "100%" }}
                          value={user.user_contact}
                          onChange={(e) => {
                            setUser({ ...user, user_contact: e.target.value });
                          }}
                        />
                      </p>
                      {isEdit ? (
                        <p>
                          <Button
                            variant="outlined"
                            onClick={handleEditProfile}
                          >
                            Save
                          </Button>
                        </p>
                      ) : (
                        ""
                      )}
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>

        <Grid item size={7} sx={{ textAlign: "center" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={value}
              aria-label="basic tabs example"
              onChange={handleChangeTab}
            >
              <Tab label="Order History" {...a11yProps(0)} />
              <Tab label="Wishlist" {...a11yProps(1)} />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            {" "}
            <OrderHistory orderHistory={orderHistory} cartItems={cartItems} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {user != null ? <Wishlist userWishlist={user.user_wishlist} /> : ""}
          </CustomTabPanel>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Profile;
